import * as React from 'react';
import { clsx } from 'clsx';
import { UIText2 } from '@cian/ui-kit';

import * as styles from './ChatOnboardingContent.css';

interface IChatOnboardingContentProps extends React.PropsWithChildren {
  wide: boolean;
}

export const ChatOnboardingContent: React.FC<IChatOnboardingContentProps> = ({ children, wide }) => {
  return (
    <div className={clsx(styles['content'], wide && styles['wide'])}>
      <UIText2 color="text-inverted-default" whiteSpace="pre-line">
        {children}
      </UIText2>
    </div>
  );
};
